const e = {
  name: "LoadingLine",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<path class="st0" d="M20,2V0C9,0,0,9,0,20c0,11,9,20,20,20c11,0,20-9,20-20h-2c0,9.9-8.1,18-18,18c-9.9,0-18-8.1-18-18S10.1,2,20,2z
	"/>
</svg>
  `
};
export {
  e as LoadingLine
};
